// What's used here of markdown-it (fof/rich-text's own copy, untyped from
// here) - its inline parser state.

/**
 * A flarum/bbcode inline tag read by the rich editor's markdown-it as a
 * mark of its own, so a post written with it shows formatted when edited
 * rather than as its tags - [color=…]…[/color], [u]…[/u]. Within one
 * paragraph, as markdown-it only ever reads inline content a paragraph at a
 * time: one spanning several stays raw text, and is published as before.
 *
 * Scanned for its closing tag token by token (markdown-it-sub's way), so a
 * closing tag inside a link's text doesn't count. Left as plain text - as
 * published, unchanged when saved again - with no closing tag, nothing in
 * between, or what the editor couldn't give back as it was:
 *
 * - the same tag inside itself: prosemirror-markdown closes every mark of a
 *   type at once, the outer one's end would be lost;
 * - inline code or maths: marks excluding all others, the formatting would
 *   be dropped from there on.
 *
 * Before a link's own "[": "[u]" or "[color=red]" is never one.
 */
export default function bbcodeMarkdownIt(mark) {
  const rule = (state, silent) => {
    const start = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(start) !== 0x5b /* [ */) return false;
    const open = mark.open.exec(state.src.slice(start, max));
    if (!open || mark.accepts && !mark.accepts(open)) return false;
    const contentStart = start + open[0].length;
    const close = mark.close.toLowerCase();
    const reopen = mark.reopen.toLowerCase();
    let found = false;
    state.pos = contentStart;
    while (state.pos < max) {
      const next = state.src.slice(state.pos, state.pos + Math.max(close.length, reopen.length)).toLowerCase();
      if (next.startsWith(close)) {
        found = true;
        break;
      }
      if (next.startsWith(reopen)) break;
      state.md.inline.skipToken(state);
    }
    const contentEnd = state.pos;
    if (!found || contentEnd === contentStart || /[`$]/.test(state.src.slice(contentStart, contentEnd))) {
      state.pos = start;
      return false;
    }
    if (!silent) {
      state.pos = contentStart;
      state.posMax = contentEnd;
      const opening = state.push(`${mark.name}_open`, 'span', 1);
      for (const [name, value] of Object.entries(mark.attrs?.(open) ?? {})) opening.attrSet(name, value);
      opening.markup = open[0];
      state.md.inline.tokenize(state);
      state.push(`${mark.name}_close`, 'span', -1).markup = mark.close;
    }
    state.pos = contentEnd + mark.close.length;
    state.posMax = max;
    return true;
  };
  return md => md.inline.ruler.before('link', mark.name, rule);
}
flarum.reg.add('champis-forum', 'forum/utils/bbcodeMarkdownIt', bbcodeMarkdownIt);